import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  logos: {
    gap: '20px',
    marginBottom: '40px',
  },
  logo: {
    height: '120px',
    width: '100%',
    '& img': {
      width: 'auto',
      height: '100%',
      objectFit: 'contain',
    },
  },
  link: {
    color: theme.palette.primary.main,
  },
  title: {
    color: theme.palette.common.white,
    fontWeight: 600,
  },
}));

export default useStyles;
